
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/prestamos/calculadora",
      function () {
        return require("private-next-pages/prestamos/calculadora/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/prestamos/calculadora"])
      });
    }
  